/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from "react";
import {
  DragDropContext,
  DropResult,
  Droppable,
  Draggable,
} from "@hello-pangea/dnd";
import Switch from "@mui/material/Switch";
import { Formik, Form } from "formik";
import LeadCaptureFormElements from "./create-lead-capture-form-elements";
import {
  StyledColumn,
  StyledList,
  StyledItem,
  StyledItemMain,
  StyledColumns,
  } from "./create-lead-capture-form-constant";
import {
  onDragEnd,
  handleClose,
  handleRequiredCheckBox,
} from "./create-lead-capture-form-helper";
import closecIcon from "../../../assets/icons/closecIcon.svg";
import "./create-lead-capture-form.scss";

const CreateLeadCaptureFormDragDrop = (props: any) => {
  const {
    columns,
    setColumns,
    formName,
    setFormName,
    handlePreview,
    formTitleError,
    setFormTitleError,
  } = props;
  const initialColumns = {
  sub: {
    id: "sub",
    list: [
      {
        title: "firstName",
        id: 1,
        isRequired: true,
        isShowRequired: false,
        showClose: true,
      },
      {
        title: "lastName",
        id: 3,
        isRequired: true,
        isShowRequired: false,
        showClose: true,
      },
      {
        title: "email",
        id: 10,
        isRequired: true,
        isShowRequired: false,
        showClose: true,
      },
    ],
  },
  main: {
    id: "main",
    list: [
      {
        title: "uploadPhoto",
        id: 0,
        isRequired: false,
        isShowRequired: true,
      },
      { title: "middleName", id: 2, isRequired: false, isShowRequired: true },
      { title: "primaryPhoneNumber", id: 18, isRequired: false, isShowRequired: true },
       { title: "interestedProduct", id: 20, isRequired: false, isShowRequired: true },
      { title: "preferredContactMode", id: 4, isRequired: false, isShowRequired: true },
      { title: "company", id: 5, isRequired: false, isShowRequired: true },
      { title: "age", id: 7, isRequired: false, isShowRequired: true },
      {
        title: "maritalStatus",
        id: 8,
        isRequired: false,
        isShowRequired: true,
      },
      {
        title: "secondaryPhoneNumber",
        id: 9,
        isRequired: false,
        isShowRequired: true,
      },
      {
        title: "secondaryEmail",
        id: 27,
        isRequired: false,
        isShowRequired: true,
      },
      { title: "website", id: 11, isRequired: false, isShowRequired: true },
      { title: "fax", id: 12, isRequired: false, isShowRequired: true },
      { title: "industry", id: 13, isRequired: false, isShowRequired: true },
      {
        title: "designation",
        id: 14,
        isRequired: false,
        isShowRequired: true,
      },
      {
        title: "description",
        id: 26,
        isRequired: false,
        isShowRequired: true,
      },
      {
        title: "address",
        id: 25,
        isRequired: false,
        isShowRequired: true,
      },
      // { title: "city", id: 17, isRequired: false, isShowRequired: true },
      // { title: "state", id: 18, isRequired: false, isShowRequired: true },
      // { title: "country", id: 19, isRequired: false, isShowRequired: true },
      // { title: "zipcode", id: 20, isRequired: false, isShowRequired: true },
      // {
      //   title: "description",
      //   id: 21,
      //   isRequired: false,
      //   isShowRequired: true,
      // },
    ],
  },
};

  return (
    <>
      <div className="lead-capture-form-filter-wrapper">
        <Formik
          initialValues={{}}
          enableReinitialize={true}
          onSubmit={() => {}}
        >
          {() => (
            <Form>
              <DragDropContext
                onDragEnd={({ source, destination }: DropResult) =>
                  onDragEnd(source, destination, columns, setColumns)
                }
              >
                <StyledColumns className="lead-capture-form-columns-wrapper">
                  {Object.values(columns).map((col: any) =>
                    col?.id === "sub" ? (
                      <Droppable droppableId={col?.id} key={col?.id}>
                        {(provided) => (
                          <StyledColumn className="lead-capture-form-columns-wrapper-element-one">
                            <StyledList
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              <div className="lead-capture-form-sub">
                                <div className="lead-capture-form-sub-title-wrapper">
                                  <input
                                    placeholder="Enter Title"
                                    className={`lead-capture-form-sub-title ${formTitleError ? "error" : ""}`}
                                    type="text"
                                    value={formName}
                                    onChange={(e: any) => {
                                      setFormName(e?.target?.value);
                                      if (setFormTitleError && e?.target?.value?.trim()) {
                                        setFormTitleError("");
                                      }
                                    }}
                                  />
                                  {!formName?.trim() ? (
                                    <span className="required-asterisk-input">*</span>
                                  ) : null}
                                  {formTitleError ? (
                                    <span className="title-inline-error">{formTitleError}</span>
                                  ) : null}
                                </div>
                                <div className="lead-capture-form-sub-element">
                                  {col?.list?.map((data: any, index: any) => (
                                    <Draggable
                                      draggableId={data?.title}
                                      index={index}
                                      key={data?.title}
                                    >
                                      {(provided) => (
                                        <StyledItem
                                          ref={provided.innerRef}
                                          {...(!data?.showClose
                                            ? {
                                                ...provided.draggableProps,
                                                ...provided.dragHandleProps,
                                              }
                                            : {})}
                                        >
                                          <div className="lead-capture-form-sub-element-close-section">
                                            {!data?.showClose ? (
                                              <div className="lead-capture-form-sub-element-close">
                                                <img
                                                  onClick={() => {
                                                    handleClose(
                                                      data,
                                                      col,
                                                      index,
                                                      columns,
                                                      setColumns,
                                                    );
                                                  }}
                                                  src={closecIcon}
                                                  className="lead-capture-form-sub-element-close"
                                                />
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                            <LeadCaptureFormElements
                                              data={data}
                                            />
                                            {data?.isShowRequired ? (
                                              <div className="lead-capture-form-sub-element-required">
                                                <div className="lead-capture-form-sub-element-required-text">
                                                  Required field
                                                </div>
                                                <div className="lead-capture-form-sub-element-required-button">
                                                  <Switch
                                                    inputProps={{
                                                      "aria-label":
                                                        "Color switch demo",
                                                    }}
                                                    onChange={() => {
                                                      handleRequiredCheckBox(
                                                        data,
                                                        col,
                                                        columns,
                                                        setColumns,
                                                      );
                                                    }}
                                                    value={data?.isRequired}
                                                    checked={data?.isRequired}
                                                  />
                                                </div>
                                              </div>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </StyledItem>
                                      )}
                                    </Draggable>
                                  ))}
                                  {col?.list?.length === 0 && (
                                    <div className="lead-capture-form-sub-element-empty">
                                      Drag and drop fields to start building
                                      your form.
                                    </div>
                                  )}
                                </div>
                                <div className="lead-capture-form-sub-element-add-reset-button-section">
                                  <button
                                    type="button"
                                    className="lead-capture-form-sub-element-reset-button"
                                    disabled={col?.list?.length === 0}
                                    onClick={() =>{
                                      setColumns(initialColumns)
                                       setFormName("");
                                    }
                                    }
                                  >
                                    Reset
                                  </button>
                                  <button
                                    type="button"
                                    onClick={handlePreview}
                                    className="lead-capture-form-sub-element-add-button"
                                    disabled={col?.list?.length === 0}
                                  >
                                    Preview
                                  </button>
                                </div>
                              </div>
                              {provided.placeholder}
                            </StyledList>
                          </StyledColumn>
                        )}
                      </Droppable>
                    ) : (
                      <Droppable droppableId={col?.id} key={col?.id}>
                        {(provided) => (
                          <StyledColumn className="lead-capture-form-columns-wrapper-element-two">
                            <StyledList
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                              className="lead-capture-form-columns-wrapper-element-two-box"
                            >
                              <div className="lead-capture-form-main">
                                <div className="lead-capture-form-main-title">
                                  <div className="lead-capture-form-main-title-text-main">
                                    Fields
                                  </div>
                                  <div className="lead-capture-form-main-title-text-sub">
                                    Drag and drop fields to start building your
                                    form.
                                  </div>
                                </div>
                                <div className="lead-capture-form-main-element">
                                  {col?.list?.map((data: any, index: any) => (
                                    <Draggable
                                      draggableId={data?.title}
                                      index={index}
                                      key={data?.title}
                                    >
                                      {(provided) => (
                                        <StyledItemMain
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                        >
                                          <LeadCaptureFormElements
                                            data={data}
                                          />
                                        </StyledItemMain>
                                      )}
                                    </Draggable>
                                  ))}
                                </div>
                              </div>
                              {provided.placeholder}
                            </StyledList>
                          </StyledColumn>
                        )}
                      </Droppable>
                    ),
                  )}
                </StyledColumns>
              </DragDropContext>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default CreateLeadCaptureFormDragDrop;
